
<template lang="pug">
drawer(:dismissRoute="dismissRoute")
  .drawer-title
    i.mat-icon add_circle
    | {{this.requestTitle}}

  el-form(
    :label-width='$labelWidth', label-position='right', ref='requestForm'
    v-loading='loadingForm', :model='request', :rules='rules'
    )

    el-form-item(label='Event name', prop='name')
      el-input(v-model='request.name', placeholder='Annual board meeting')

    // PEOPLE
    el-form-item(label='Number of people', prop='people')
      el-input-number(:disabled="isDisabled" v-model='request.people', :min='1')

    // BUDGET
    el-form-item(label='Budget per person', prop='budget')
      el-input(:disabled="isDisabled", v-model='request.budget')
        template(slot='prepend')
          | $
      

    // CUISINES
    el-form-item(label='Preferred cuisines', prop='cuisine_ids')
      el-select( v-if ='!isClone || this.isStaff', v-model='request.cuisine_ids', multiple='', placeholder='Select up to 3', :multipleLimit='3', class='full-width-select')
        el-option(v-for='item in cuisines', :key='item.id', :label='item.name', :value='item.id')
      span(v-else).clone-item {{order.vendor_name}}


    // ADDRESS
    el-form-item(label='Delivery address', prop='address_id')
      el-col(:span="17")
        el-select(v-model='request.address_id',   placeholder='Select an option')
          el-option(
            v-for='item in addresses', :key='item.id',
            :label='item.address_line_1', :value='item.id'
          )
          el-option(
            label='Create new address', value='new', class='select-special-action'
          )
      el-col(:span="7")
        el-form-item(v-show='request.address_id && !creatingAddress' prop='suite')
          el-input(v-model='request.suite'  placeholder='Suite')

    section-separator(v-show='creatingAddress', label='New address information')
      address-builder(ref='addressForm', label-position='right', :label-width='$labelWidth' :customerId='request.customer_id')

    // DATE
    el-form-item(label='Delivery date', prop='delivery_date')
      el-date-picker(
        :value='request.delivery_date', placeholder='Select a date',
        :pickerOptions='datePickerOptions', value-format='yyyy-MM-dd', @input='changeDeliveryDate'
      )

    // TIME
    el-form-item(label='Delivery time', prop='delivery_time')
      el-time-picker(type='date'
        placeholder='Select a time', v-model='request.delivery_time',
        :picker-options="timePickerOptions",
        format="hh:mm A",
        value-format="HH:mm"
      )
    //- pre {{ request.delivery_time }}

    // CONTACT
    //add ifClone last used 
    el-form-item(label='Contact for this request', prop='contact_id')
      el-select(v-model='request.contact_id', placeholder='Select an option')
        el-option(
          v-for='item in contacts', :key='item.id',
          :label='item.first_name + " " + item.last_name', :value='item.id'
          )
        el-option(
          label='Create new contact', value='new', class='select-special-action'
        )
    section-separator(v-show='creatingContact', label='New contact information')
      contact-builder(ref='contactForm', label-position='right', :label-width='$labelWidth')

    // NOTES

    el-form-item(label='Custom customer PO', prop='customerPO')
      el-input(v-model='order.customer_po')
    el-form-item(label='Anything we should know?', prop='notes')
      el-input(type='textarea' v-model='request.notes' max='250',
        :autosize='{ minRows: 2, maxRows: 7 }'
      )

    el-form-item(v-if='order.pickup_address_id'
      label='Pickup Address'
      prop='pickupAddressId')
      el-select(:disabled="isDisabled", v-model='order.pickup_address_id'
        placeholder='Select an option')
        el-option(v-for='item in pickupAddresses'
        :key='item.id'
        :label='item.address_line_1'
        :value='item.id')

    el-form-item(v-if='order.food_ready_time'
      label='Food ready time'
      prop='foodReadyTime')
      el-time-picker(:disabled="isDisabled", v-model='order.food_ready_time'
        placeholder='Select a time'
        format='hh:mm A',
        value-format='HH:mm')

    el-form-item(v-if='order.vendor_order_notes'
      prop='vendorNotes'
      label='Staff notes on order')
      el-input(:disabled="isDisabled", v-model='order.vendor_order_notes'
        placeholder='Add notes')

    el-form-item(v-if='order.purchase_order_notes'
      prop='purchaseNotes'
      label='Notes to vendor')
      el-input(:disabled="isDisabled", v-model='order.purchase_order_notes'
        placeholder='Add notes')

    el-collapse(v-show='!isClone')
      el-collapse-item(name='preferences')
        template(slot='title')
          el-form-item(label='Preferences')
            span.collapse-item__tip Click to expand
        el-form-item(prop='preferences')
          preferences-builder(
            :initialValue='preferences',
            ref='preferencesForm',
            :is-request='true'
          )


    // BUTTONS
    el-form-item.buttons-section
      el-button(type='primary' @click='onSubmit', :loading='submitting')
        | Save
      el-button(@click='onCancel')
        | Cancel
    el-row(v-show='isClone && !this.isStaff' :gutter='$rowGutter', style='font-size: 0.9rem; text-align: center; color: #888;')
      el-col(:span='24')
        | Order is not confirmed until reviewed by staff
</template>

<style scoped lang="sass">
@import '../../variables'

.collapse-item__tip
  font-style: italic
  opacity: 0.8
  display: inline-block
  float: right
  margin-right: 1rem
  font-weight: 600
  color: $colorPrimary
  &:hover
    opacity: 1

.clone-item
  font-style: italic
  opacity: 0.8
  display: inline-block
  margin-right: 1rem
  font-weight: 600
  color: $colorPrimary
.drawer .el-collapse-item__header, .drawer .el-collapse-item__wrap
  background-color: #FAFAFA
</style>


<script>
import ContactBuilder from "../../user/blocks/ContactBuilder.vue";
import AddressBuilder from "../../common/AddressBuilder.vue";
import PreferencesBuilder from "../../user/blocks/PreferencesBuilder.vue";
import Vue from "vue";

function emptyRequest() {
  return {
    notes: "",
    cuisine_ids: [],
    people: null,
    budget: null,
    contact_id: null,
    customer_id: null,
    address_id: null,
    delivery_date: null,
    delivery_time: null,
    suite: null
  };
}

function loadRequest() {
  const id = this.$route.params.id;
  this.requestTitle = ( !this.isClone && id ) ? "Edit" : "New Request";
  this.dismissRoute = this.$route.matched[1].path;
  if (id) {
    this.$simplecater
      .get("/requests/" + id)
      .then(r => {
        const data = r.data.data;

        this.request = {
          address_id: data.address_id,
          budget: data.budget_cents / 100,
          contact_id: data.contact_id,
          customer_id: data.customer_id,
          cuisine_ids: data.cuisines.map(e => e.id).filter(e => e !== 0),
          delivery_date: (this.isClone) ? '' : data.delivery_date,
          delivery_time: (this.isClone) ? '' : data.delivery_time,
          notes: (this.isClone) ? '' : data.notes,
          people: data.people,
          name: (this.isClone) ? '' : data.name,
          suite: data.suite,
          id: data.id
        };

        if( this.isClone ) this.requestTitle = `Cloning Order '${data.name}'`;
        this.preferences = data.preferences;

        this.order.vendor_name = data.order.vendor_name;
        this.order.customer_po = (this.isClone) ? null : data.customer_po;
        this.order.pickup_address_id = (this.isClone) ? null : data.order.pickup_address_id;
        this.order.food_ready_time = (this.isClone) ? null : data.order.food_ready_time;
        this.order.vendor_order_notes = (this.isClone) ? null : data.order.vendor_order_notes;
        this.order.purchase_order_notes = (this.isClone) ? null : data.order.purchase_order_notes;

        if (this.isStaff) {
          this.getAddresses(this.request.address_id);
          this.getContacts(this.request.contact_id);
        }
      })
      .catch(() => {
        this.$message.error("Failed to load order's request");
      });
  }
}

function loadOrder() {
  const target = `/orders/${this.orderId}`;
  return this.$simplecater
    .get(target)
    .then(r => {
      this.order = r.data.data;
      this.order.pickup_address_id ? this.getPickupAddresses() : null;
    })
    .catch(() => {
      this.$message.error("Failed to load the order");
    });
}

function sendOrder() {
  const params = {};
  this.order.pickup_address_id
    ? (params.pickup_address_id = this.order.pickup_address_id)
    : null;
  this.order.delivery_date
    ? (params.delivery_date = this.order.delivery_date)
    : null;
  this.order.vendor_order_notes
    ? (params.vendor_order_notes = this.order.vendor_order_notes)
    : null;
  this.order.purchase_order_notes
    ? (params.purchase_order_notes = this.order.purchase_order_notes)
    : null;
  this.order.food_ready_time
    ? (params.food_ready_time = this.order.food_ready_time)
    : null;
  this.order.customer_po ? (params.customer_po = this.order.customer_po) : "";
  return this.$simplecater.put(`/orders/${this.order.id}`, params);
}

function changeDeliveryDate(value) {
  this.order.delivery_date = value;
  this.request.delivery_date = value;
}

function buildFormRules(componentInstance) {
  return {
    name: {
      required: true,
      message: "Please enter a name for your request",
      trigger: "blur"
    },
    notes: {
      max: 250,
      message: "Notes cannot exceed 250 characters",
      trigger: "change"
    },
    cuisine_ids: {
      type: "array",
      required: true,
      trigger: "change",
      message: "Please select at least one cuisine"
    },
    people: {
      required: true,
      type: "integer",
      message: "Please input the number of people",
      trigger: "blur"
    },
    budget: {
      required: true,
      type: "number",
      message: "Please input a valid budget per person in dollars",
      trigger: "blur",
      transform: parseFloat
    },
    contact_id: [
      { validator: validateContact.bind(componentInstance), trigger: "change" },
      { required: true, trigger: "change" }
    ],
    address_id: [
      { validator: validateAddress.bind(componentInstance), trigger: "change" },
      { required: true, trigger: "change" }
    ],
    delivery_date: {
      required: true,
      message: "Please pick a date",
      trigger: "change"
    },
    delivery_time: {
      required: true,
      message: "Please pick a time",
      trigger: "change",
      pattern: /\d{2}:\d{2}/
    }
  };
}

function data() {
  return {
    isStaff: this.$route.matched[0].path === "/staff",
    requestTitle: "",
    dismissRoute: "",
    rules: buildFormRules(this),
    skipNestedFormsValidation: true,
    loadingForm: true,
    displayContactForm: false,
    displayAddressForm: false,
    cuisines: [],
    contacts: [],
    addresses: [],
    pickupAddresses: [],
    order: {},
    dataForSubmit: null,
    submitting: false,
    request: emptyRequest(),
    preferences: {},
    isContactValid: false,
    datePickerOptions: {
      disabledDate(time) {
        const today = new Date();
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        return time < yesterday;
      }
    },
    timePickerOptions: {
      selectableRange: "07:00:00 - 19:30:00"
    }
  };
}

function created() {
  if (this.isStaff) {
    this.getStaffData();
  } else {
    this.getUserData();
  }

  // TODO add catch
}

function getUserData() {
  Promise.all([
    this.getContacts(),
    this.getAddresses(),
    this.getPreferences(),
    this.getCuisines(),
    this.loadRequest()
  ]).then(() => {
    console.log("RESOLVED!");
    this.loadingForm = false;
  });
}

function getStaffData() {
  const requests = [this.getCuisines(), this.loadRequest()];
  if (this.orderId) requests.push(this.loadOrder());
  Promise.all(requests).then(() => {
    this.loadingForm = false;
  });
}

function getCuisines() {
  return this.$simplecater.get("/cuisines").then(r => {
    this.cuisines = _.sortBy(r.data.data, x => x.name.toLowerCase());
  });
}

function getAddresses(id) {
  const apiUrl = id ? "/addresses" + "/" + id : "/addresses";
  return this.$simplecater.get(apiUrl).then(r => {
    if (this.isStaff) {
      this.addresses.push(r.data.data);
    } else {
      this.addresses = _.sortBy(r.data.data, "address_line_1");
    }
  });
}

function getPickupAddresses() {
  this.$simplecater
    .get(`/vendors/${this.order.vendor_id}/addresses`)
    .then(r => {
      this.pickupAddresses = r.data.data;
    });
}

function getPreferences() {
  this.$simplecater.get("/preferences").then(r => {
    this.preferences = r.data.data;
    this.request.budget = this.preferences.budget_cents / 100;
  });
}

function getContacts(id) {
  const apiUrl = id ? "/contacts" + "/" + id : "/contacts";
  return this.$simplecater.get(apiUrl).then(r => {
    if (this.isStaff) {
      this.contacts.push(r.data.data);
    } else {
      this.contacts = _.sortBy(r.data.data, x => x.first_name.toLowerCase());
    }
  });
}

function onCancel() {
  this.$router.push(this.dismissRoute);
}

function validateContact(rule, value, callback) {
  if (value === null) return callback(new Error("Please select an option"));
  if (value === "new") {
    if (this.skipNestedFormsValidation) return callback();
    this.$refs.contactForm.validate(callback);
  } else {
    if (Number.isInteger(value)) {
      callback();
    } else {
      callback(new Error("Please give a valid id"));
    }
  }
}

function validateAddress(rule, value, callback) {
  if (value === null) return callback(new Error("Please select an option"));
  if (value === "new") {
    if (this.skipNestedFormsValidation) return callback();
    this.$refs.addressForm.validate(callback);
  } else {
    if (Number.isInteger(value)) {
      callback();
    } else {
      callback(new Error("Please give a valid id"));
    }
  }
}

function createContact() {
  console.log("Creating contact");
  return this.$refs.contactForm.create().then(newContact => {
    this.dataForSubmit.contact_id = newContact.id;
  });
}

function createAddress() {
  console.log("Creating address");
  return this.$refs.addressForm.create().then(newAddress => {
    this.dataForSubmit.address_id = newAddress.id;
  });
}

// This the click event handles, only triggers submission if validations pass
function onSubmit() {
  this.skipNestedFormsValidation = false;
  this.$refs.requestForm.validate(valid => {
    if (valid) {
      this.submitForm();
    } else {
      this.$message.error("Some validations failed, please check your inputs");
      return false;
    }
  });
}

// This the actual submission after validation
function submitForm() {
  this.submitting = true;
  let promises = [];
  // We copy the request, because setting contact or address id would produce
  // unwanted UI changes (forms disappearing, unexpected select values...)
  this.dataForSubmit = Object.assign({}, this.request);
  if (this.order.customer_po){
    this.dataForSubmit.customer_po = this.order.customer_po;
  }
  this.dataForSubmit.preferences = Object.assign(
    {},
    this.$refs.preferencesForm.preferences
  );
  this.dataForSubmit.budget_cents = this.request.budget * 100;
  this.dataForSubmit.delivery_date = this.dataForSubmit.delivery_date;
  if(this.isClone) this.dataForSubmit.original_request_id = this.request.id
  // Do we have to create a contact?
  if (this.creatingContact) promises.push(this.createContact());
  // Do we have to create an address?
  if (this.creatingAddress) promises.push(this.createAddress());
  
  if (this.orderId && !this.isClone) promises.push(this.sendOrder());
  Promise.all(promises).then(() => {
    const id = this.$route.params.id;

    const getRequestType = () => {
      if (id && !this.isClone && !this.isStaff) {
        return this.$simplecater.put(`/requests/${id}`, this.dataForSubmit);
      } else if(this.isStaff && this.isClone) {
        return this.$simplecater.post(`/customers/${this.request.customer_id}/requests`, this.dataForSubmit); 
      }else{
        return this.$simplecater.post("/requests", this.dataForSubmit);
      }
    };
    getRequestType()
      .then(r => {
        // SUBMIT SUCCEEDED
        const message =
          this.isStaff || id ? "Data updated" : "Your request has been sent";
        this.$bus.$emit("request-created");
        this.$message(message);
        // RESET FIELDS
        this.request = emptyRequest();
        Vue.nextTick(() => {
          this.$router.push(this.dismissRoute);
        });
      })
      .catch(
        // SUBMIT FAILED
        this.$handleErrorFor("Creating request").bind(this)
      )
      .finally(() => {
        this.submitting = false;
      });
  });
}

function updatePreferences(newValue) {
  console.log("NEW PREFS!", newValue);
}

const computed = {
  creatingAddress: function() {
    return this.request.address_id == "new";
  },
  creatingContact: function() {
    return this.request.contact_id == "new";
  },
  orderId() {
    return this.$route.query.orderId ? this.$route.query.orderId : "";
  },
  isClone(){
    return (this.$route.name ==='CLONE')? true : false;
  },
  isDisabled(){
    return (this.$route.name ==='CLONE' && !this.isStaff) ? true : false;
  }
};

const components = { ContactBuilder, AddressBuilder, PreferencesBuilder };

const methods = {
  getContacts,
  getAddresses,
  getCuisines,
  getPreferences,
  submitForm,
  getPickupAddresses,
  onCancel,
  onSubmit,
  createContact,
  validateContact,
  validateAddress,
  sendOrder,
  createAddress,
  updatePreferences,
  loadRequest,
  getUserData,
  getStaffData,
  loadOrder,
  changeDeliveryDate
};

export default { data, created, components, methods, computed };
</script>



// WEBPACK FOOTER //
// src/layout/Blocks/RequestBuilder.vue